import React from "react"
import PropTypes from "prop-types"
import { Divider, Flex, Switch, Tooltip } from "antd"
import { InfoCircleOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import MultiSelectWithSearch from "components/common/MultiSelectWithSearch"
import { ResourceCard } from "../ResourceCard"
import { EquipmentTable } from "../EquipmentTable"
import styles from "../../index.module.css"
import { Text } from "ui/Typography"

export const EquipmentSection = ({
  equipmentData,
  selectedEquipment,
  onEquipmentChange,
  selectedEquipmentData,
  onEdit,
  onRemove,
  onAddClick,
  autoAssignEquipment,
  onAutoAssignChange,
  equipmentError
}) => {
  const { t } = useTranslation()

  const equipmentOptions = [
    { value: "all", label: "Select All" },
    ...(equipmentData || []).map((equipment) => {
      return {
        value: String(equipment.id),
        label: equipment.name || equipment.equipment_title,
        status: equipment.status
      }
    })
  ]

  const hasSelection = (selectedEquipment || []).length > 0

  return (
    <ResourceCard
      title={t("listings.tabs.resources.select_equipment")}
      buttonText={t("listings.tabs.resources.add_new_equipment")}
      onAddClick={onAddClick}
    >
      <div className="mt-l">
        <Text fw={500}>
          {t("listings.tabs.resources.select_equipment")}
          <span className={styles.requiredMark}>*</span>
        </Text>
        <MultiSelectWithSearch
          value={selectedEquipment || []}
          onChange={onEquipmentChange}
          options={equipmentOptions}
          placeholder={t("listings.tabs.resources.select_equipment_placeholder", { defaultValue: "Select equipment to add" })}
          searchPlaceholder="Search equipment"
          style={{ minWidth: "100%", maxWidth: "100%" }}
          t={t}
        />
        {!hasSelection && (
          <Text size="caption" className={styles.emptyExperiencesText}>
            {t("equipment.no_experience_assigned", { defaultValue: "No equipment assigned yet." })}
          </Text>
        )}
      </div>

      {hasSelection && <EquipmentTable data={selectedEquipmentData} onEdit={onEdit} onRemove={onRemove} />}

      <Divider className="my-l" />

      <Text fw={500}>{t("listings.tabs.resources.booking_rules", { defaultValue: "Booking Rules" })}</Text>
      <Flex align="center" className="mt-s" gap={8} wrap>
        <Switch checked={autoAssignEquipment} onChange={onAutoAssignChange} />
        <Text>{t("listings.tabs.resources.booking_requires_equipment")}</Text>
        <Tooltip
          title={
            <div>
              <p>{t("listings.tabs.resources.booking_requires_equipment_tooltip_on_description")}</p>
              <p>{t("listings.tabs.resources.booking_requires_equipment_tooltip_off_description")}</p>
            </div>
          }
        >
          <InfoCircleOutlined className={styles.infoIcon} />
        </Tooltip>
      </Flex>
    </ResourceCard>
  )
}

EquipmentSection.propTypes = {
  equipmentData: PropTypes.array.isRequired,
  selectedEquipment: PropTypes.array.isRequired,
  onEquipmentChange: PropTypes.func.isRequired,
  selectedEquipmentData: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onAddClick: PropTypes.func.isRequired,
  autoAssignEquipment: PropTypes.bool.isRequired,
  onAutoAssignChange: PropTypes.func.isRequired,
  equipmentError: PropTypes.string
}
